export default {
  data() {
    return {
      observer: null,
      observerOptions: {
        threshold: [0.1],
      },
    }
  },
  methods: {
    setActionsMenuVisibility(entries) {
      const visible = entries[0].isIntersecting;
      this.$emit('actionsMenuVisibility', visible);
      this.$store.dispatch('setActionsMenuVisibility', visible);
    },
  },
  updated() {
    if (this.$refs['actionsMenu']) {
      this.observer.observe(this.$refs['actionsMenu']);
    }
  },
  mounted() {
    this.observer = new IntersectionObserver(this.setActionsMenuVisibility, this.observerOptions);

    if (this.$refs['actionsMenu']) {
      this.observer.observe(this.$refs['actionsMenu']);
    }
  },
  beforeDestroy() {
    this.observer.disconnect();
  },
};
